<template>
  <div class="formNav">
    <div class="header" @click="goIndex"><h3>资质查验</h3><h3>Qualification inquiry</h3></div>
    <div class="boxForm" style="width: 100%; margin-top: -70px">
      <div class="contentnav" style="width: 1100px; margin: 0 auto">
        <div class="itemInfor">
          <!-- <img src="../assets/noPass.png" alt="" /> -->
          <img src="../assets/pass.png" alt="" />
          <h3>审核通过</h3>
          <div class="contaniner-item">
            恭喜您，您申请的 <a> 知识产权质量评价人员</a> 已通过审核！
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
    
    <script>
import Foot from "./Foot.vue";
export default {
  name: "",
  components: { Foot },
  props: {},
  data() {
    return {
      activeName: "1",
      ruleForm: {},
      certCodeShow: false,
      rules: {
        name: [
          { required: true, message: "请填写资质上的姓名", trigger: "blur" },
        ],
        idCard: [
          {
            required: true,
            message: "请填写资质上的身份证件号码",
            trigger: "blur",
          },
        ],
        certCode: [
          {
            required: true,
            message: "请填写资质上的编号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    goIndex() {
      this.$router.push({ name: "index" });
    },
    handleClick() {
      if (this.activeName == 1) {
        this.certCodeShow = false;
      } else {
        this.certCodeShow = true;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
    
    <style scoped lang="less">
.formNav {
  width: 100%;
  .header {
    padding-top: 120px;
    box-sizing: border-box;
    height: 450px;
    font-size: 30px;
    text-align: left;
    background: url("../assets/zizhibanner.png") 100% 100% no-repeat;
    background-size: 100% 100%;
    color: #fff;
    h3 {
      width: 1100px;
      margin: 0 auto;
      margin-bottom: 30px;
     font-weight: normal;
    }
    :last-child{
      font:lighter 50px/80px PMingLiU;
      color:#c5c4c4;
        // font-style: SourceHanSansCN-Light;
      }
  }
}
.boxForm {
  // padding-top: 30px;
  margin-bottom: 30px;
}
.contentnav {
  background: #fff;
  padding: 0 50px;
  min-height: 600px;
  border-radius: 15px;
  box-sizing: border-box;
  box-shadow: 1px 2px 2px 0px #f0f0f0;

  h3 {
    text-align: left;
    line-height: 50px;
    padding: 10px;
    // margin-bottom: 50px;
    font-size: 20px;
    // border-bottom: 1px solid #cfcece;
  }
  .itemInfor {
    width: 80%;
    height:500px;
    margin: 20px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
      img {
        width: 100px;
        height: 80px;
      }
      .contaniner-item{
        font-size: 14px;
        color: #999;
        a{
            color: #607fea;
        }
      }
  }
  .userInfor {
    // width: 60%;
    line-height: 30px;
    font-size: 14px;
    // margin-right: 40px;
    p {
      display: flex;
      justify-content: space-between;
    }
  }
  .btn {
    // margin: 30px 0;
    margin-bottom: 30px;
    .el-button {
      padding: 12px 20px;
    }
  }
  .titleNew {
    border: 1px solid #607fea;
    background: #e1e7fd;
    padding: 10px 25px;
    width: 500px;
    margin: 0 auto;
    color: #607fea;
    font-size: 14px;
    border-radius: 4px;
  }
}
.forminspect {
  width: 500px;
  margin: 30px;
  // ::v-deep .el-input__inner {
  //   width: 300px;
  // }
  .itemFlex {
    display: flex;
    align-items: center;
    // margin-left: 20px;
    // margin-top: 30px;
    img {
      margin-left: 10px;
      margin-bottom: 20px;
    }
  }
  ::v-deep .el-button--primary {
    width: 320px;
    margin-left: 10px;
  }
}
.el-form-item {
  text-align: left;
}
::v-deep .el-form-item__content {
  // display: flex;
  // justify-content: space-around;
}
</style>
    